module.exports = __webpack_public_path__ + "static/img/word.svg";